import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";


export function summaryTextOne(customerName, applicationName, testStartDate, testEndDate) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            else {
                switch (day % 10) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
        }
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const formattedDate = `${date.getDate()}`;
        const ordinalSuffix = getOrdinalSuffix(date.getDate());
        const formatMonth = monthNames[date.getMonth()];
        const formatYear = date.getFullYear();

        return {
            formattedDate,
            ordinalSuffix,
            formatMonth,
            formatYear
        };
    };

    const formattedStartDate = formatDate(testStartDate);
    const formattedEndDate = formatDate(testEndDate);
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600 },
        // spacing: { before: 150 },
        spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
        alignment: AlignmentType.LEFT,
        children: [
            new TextRun({
                text: `${customerName} engaged ISECURION for performing Penetration Testing of their ${applicationName} Mobile Application. The testing was executed from`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formattedDate,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),

            new TextRun({
                text: formattedStartDate.ordinalSuffix,
                superScript: true,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedStartDate.formatMonth + ' ' + formattedStartDate.formatYear + ' ',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: 'to',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formattedDate,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: formattedEndDate.ordinalSuffix,
                superScript: true,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: ' ' + formattedEndDate.formatMonth + ' ' + formattedEndDate.formatYear + ' ',
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
            new TextRun({
                text: "from ISECURION premises.",
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            })
        ],
    });
}



export function summaryText3(environmentType, testingType, applicationName) {
    return new Paragraph({
        width: { size: 100, type: WidthType.PERCENTAGE },
        indent: { left: 600, right: 600 },
        // spacing: { before: 250 },
        spacing: { line: 276, before: 20 * 72 * 0.1 },
        alignment: AlignmentType.LEFT,
        children: [
            new TextRun({
                text: `Testing was performed on the ${applicationName} ${environmentType} Environment. ${testingType} ${testingType === "Black box testing methodology (Unauthenticated Testing)"
                        ? "was performed."
                        : "was performed with below-mentioned user roles:"
                    }`,
                size: 24,
                font: "Calibri",
                color: '0f0f3f',
                italics: false
            }),
        ],
    })
}